import { useEffect } from 'react';
import { useAuthInfo } from '@propelauth/react';
import useTokenRefresh from '../hooks/useTokenRefresh';
import { isDevelopment } from '../utils/env';

/**
 * TokenRefreshWrapper - A component that handles token refresh
 * 
 * This component should be placed inside the AuthProvider and 
 * will automatically refresh the token before it expires.
 */
const TokenRefreshWrapper: React.FC = () => {
    const authInfo = useAuthInfo();

    // Initialize token refresh with shorter threshold in development
    const { lastRefreshTime } = useTokenRefresh({
        refreshThreshold: isDevelopment() ? 60 : 300, // 1 minute in dev, 5 minutes in prod
        enableLogging: isDevelopment(),
    });

    // Additional monitoring for development
    useEffect(() => {
        if (isDevelopment()) {
            console.log(`[TokenRefreshWrapper] Initialized at ${new Date().toISOString()}`);
            console.log(`[TokenRefreshWrapper] Auth state: ${authInfo?.isLoggedIn ? 'Logged in' : 'Not logged in'}`);

            return () => {
                console.log(`[TokenRefreshWrapper] Unmounting at ${new Date().toISOString()}`);
            };
        }
    }, [authInfo?.isLoggedIn]);

    return null; // This component doesn't render anything
};

export default TokenRefreshWrapper; 